/** @format */

import React, { useEffect, useState } from "react";
import axios from "axios";
import { header } from "../../../../../components/api/Header";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../lib/env";

function Balanslar({ date, a, s, z }) {
  const [balans, setBalans] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBalans = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/dashboard/balanslar?date=" +
            date,
          header()
        );
        setBalans(res.data);
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan aloqa yo'q!");
      } finally {
        setLoading(false);
      }
    };
    fetchBalans();
  }, [date]);

  if (loading) {
    return <LoadingCard loading={loading} heightSize='20vh' />;
  }

  return (
    <>
      {a ? (
        <div className='card statistic-card card1'>
          <h4 className='title text-center'>
            Amudaryo balansi (
            <span className='lower'>
              m<sup>3</sup>/s{" "}
            </span>
            )
          </h4>

          <ul className='lists row'>
            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["a"]["u"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /{balans ? foiz(balans["a"]["u"], balans["a"]["t"]) : "-"}%
                </span>
              </div>

              <p>O'zbekiston</p>

              <div
                className='vertical-line'
                style={{ backgroundColor: "#0077FF" }}></div>
            </li>

            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["a"]["t"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /{balans ? foiz(balans["a"]["t"], balans["a"]["u"]) : "-"}%
                </span>
              </div>

              <p>Turkmaniston</p>

              <div
                className='vertical-line'
                style={{ backgroundColor: "#0077FF" }}></div>
            </li>
          </ul>
        </div>
      ) : null}

      {s ? (
        <div className='card statistic-card card2'>
          <h4 className='title text-center'>
            Sirdaryo balansi (
            <span className='lower'>
              m<sup>3</sup>/s{" "}
            </span>{" "}
            )
          </h4>

          <ul className='lists row'>
            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["s"]["u"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /
                  {balans
                    ? foiz2(
                        balans["s"]["u"],
                        balans["s"]["t"],
                        balans["s"]["q"]
                      )
                    : "-"}
                  %
                </span>
              </div>
              <p>O'zbekiston</p>

              <div
                className='vertical-line'
                style={{ backgroundColor: "#FBB214" }}></div>
            </li>

            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["s"]["t"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /
                  {balans
                    ? foiz2(
                        balans["s"]["t"],
                        balans["s"]["u"],
                        balans["s"]["q"]
                      )
                    : "-"}
                  %
                </span>
              </div>

              <p>Tojikiston</p>

              <div
                className='vertical-line'
                style={{ backgroundColor: "#FBB214" }}></div>
            </li>

            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["s"]["q"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /
                  {balans
                    ? foiz2(
                        balans["s"]["q"],
                        balans["s"]["t"],
                        balans["s"]["u"]
                      )
                    : "-"}
                  %
                </span>
              </div>

              <p>Qozog'iston</p>

              <div
                className='vertical-line'
                style={{ backgroundColor: "#FBB214" }}></div>
            </li>
          </ul>
        </div>
      ) : null}

      {z ? (
        <div className='card statistic-card card3'>
          <h4 className='title text-center'>
            Zarafshon daryosi balansi (
            <span className='lower'>
              m<sup>3</sup>/s{" "}
            </span>{" "}
            )
          </h4>

          <ul className='lists row'>
            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["z"]["s"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /
                  {balans
                    ? foiz2(
                        balans["z"]["s"],
                        balans["z"]["n"],
                        balans["z"]["q"],
                        balans["z"]["j"]
                      )
                    : "-"}
                  %
                </span>
              </div>

              <p>Samarqand</p>

              <div
                className='vertical-line'
                style={{ backgroundColor: "#9747FF" }}></div>
            </li>

            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["z"]["n"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /
                  {balans
                    ? foiz2(
                        balans["z"]["n"],
                        balans["z"]["s"],
                        balans["z"]["q"],
                        balans["z"]["j"]
                      )
                    : "-"}
                  %
                </span>
              </div>

              <p>Navoiy</p>

              <div
                className='vertical-line'
                style={{ backgroundColor: "#9747FF" }}></div>
            </li>

            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["z"]["q"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /
                  {balans
                    ? foiz2(
                        balans["z"]["q"],
                        balans["z"]["s"],
                        balans["z"]["n"],
                        balans["z"]["j"]
                      )
                    : "-"}
                  %
                </span>
              </div>

              <p>Qashqadaryo</p>

              <div
                className='vertical-line'
                style={{ backgroundColor: "#9747FF" }}></div>
            </li>

            <li className='col'>
              <div className='head'>
                <h3>{balans ? fix(balans["z"]["j"]) : "-"}</h3>
                <span style={{ color: "#0077FF" }}>
                  /
                  {balans
                    ? foiz2(
                        balans["z"]["j"],
                        balans["z"]["s"],
                        balans["z"]["n"],
                        balans["z"]["s"]
                      )
                    : "-"}
                  %
                </span>
              </div>
              <p>Jizzax</p>
              <div
                className='vertical-line'
                style={{ backgroundColor: "#9747FF" }}></div>
            </li>
          </ul>
        </div>
      ) : null}
    </>
  );
}

export default Balanslar;

const foiz = (a, b) => {
  if (!a || typeof a == "undefined") {
    a = 0;
  }
  if (!b || typeof b == "undefined") {
    b = 0;
  }
  if (a == 0) {
    return 0;
  } else {
    if (b == 0) {
      return 100;
    } else {
      let fa = (a * 100) / (a + b);
      if (fa % 1 != 0) return fa.toFixed(1);
      return fa;
    }
  }
};

const fix = (v) => {
  if (!v || typeof v == "undefined" || v === "-") {
    return "-";
  } else {
    return parseFloat(v).toFixed(1);
  }
};

const foiz2 = (a, b, c, d = 0) => {
  if (!a || typeof a == "undefined") {
    a = 0;
  }
  if (!b || typeof b == "undefined") {
    b = 0;
  }
  if (!c || typeof c == "undefined") {
    c = 0;
  }
  if (a == 0) {
    return 0;
  } else {
    let s = parseFloat(a) + parseFloat(b) + parseFloat(c) + parseFloat(d);
    let f = (a * 100) / s;
    if (f % 1 != 0) return f.toFixed(1);
    return f;
  }
};
